export default "__VITE_ASSET__DeiPP8cQ__"